import { render } from "./LanguageLevel.vue?vue&type=template&id=22a7c820&scoped=true"
import script from "./LanguageLevel.vue?vue&type=script&lang=js"
export * from "./LanguageLevel.vue?vue&type=script&lang=js"

import "./LanguageLevel.vue?vue&type=style&index=0&id=22a7c820&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a7c820"]])

export default __exports__